import { createContext, useContext, useMemo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const H7Context = /*#__PURE__*/createContext(undefined);
export const H7Provider = ({
  headingStyleOverrides,
  children
}) => {
  const value = useMemo(() => ({
    headingStyleOverrides
  }), [headingStyleOverrides]);
  return /*#__PURE__*/_jsx(H7Context.Provider, {
    value: value,
    children: children
  });
};

/**
 * Provides the context for the `H7` component.
 * Note: The context is only available when the `H7` component is rendered as an ancestor.
 * @returns H7Context - The context for the `H7` component.
 * @returns H7Context.headingStyleOverrides - Style overrides to be applied to the `Heading` component.
 */
export const useH7Context = () => {
  const h7Context = useContext(H7Context);
  return h7Context;
};